class ProductMediaPagination extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const paginationElement = this;
    if (paginationElement) {
      this.pagination_functionality_on_load(paginationElement);
      paginationElement.querySelectorAll("button").forEach((element) => {
        element.addEventListener("click", (event) => {
          const clicked_pagination_dot = event.target;
          const pagination_dot_id =
            clicked_pagination_dot.getAttribute("data-media-id");

          const media_thumbnails = document.querySelectorAll(
            ".thumbnail-list .thumbnail-list__item"
          );

          media_thumbnails.forEach((thumbnail) => {
            const current_Thumbnail = thumbnail.querySelector(
              "button[aria-current='true']"
            );
            let current_thumbnail_id = null;

            if (current_Thumbnail) {
              current_thumbnail_id =
                current_Thumbnail.getAttribute("thumbnail-media-id");

              if (
                pagination_dot_id &&
                current_thumbnail_id === pagination_dot_id
              ) {
                paginationElement.querySelectorAll("button").forEach((btn) => {
                  btn.classList.remove("active-pagination");
                });

                clicked_pagination_dot.classList.add("active-pagination");
              }
            } else {
              const thumbnail_button = thumbnail.querySelector("button");
              const media_Id_of_thumbnail =
                thumbnail_button.getAttribute("thumbnail-media-id");

              if (media_Id_of_thumbnail == pagination_dot_id) {
                thumbnail_button.click();
                current_thumbnail_id = media_Id_of_thumbnail;

                if (
                  pagination_dot_id &&
                  current_thumbnail_id === pagination_dot_id
                ) {
                  paginationElement
                    .querySelectorAll("button")
                    .forEach((btn) => {
                      btn.classList.remove("active-pagination");
                    });

                  clicked_pagination_dot.classList.add("active-pagination");
                }
              }
            }
          });
        });
      });
    }
  }

  pagination_functionality_on_load(paginationElement) {
    const media_thumbnails = document.querySelectorAll(
      ".thumbnail-list .thumbnail-list__item"
    );
    let current_thumbnail_id = null;
    
    function findThumbnailId(ms) {
      return new Promise((resolve) => {
          media_thumbnails.forEach((thumbnail) => {
            const current_Thumbnail = thumbnail.querySelector(
              'button[aria-current="true"]'
            );
            
            if (current_Thumbnail) {
              current_thumbnail_id =
                current_Thumbnail.getAttribute("thumbnail-media-id");
            }
          });
      });
    }
    async function syncThumbnailId(){
      await findThumbnailId();
    }
    syncThumbnailId();
    paginationElement
      .querySelector(`button[data-media-id="${current_thumbnail_id}"]`)?.classList.add("active-pagination");
  }
}

customElements.define("product-media-pagination", ProductMediaPagination);



// 
document.querySelectorAll(".details-tabs-labels-list-item").forEach((element)=> {
    element.addEventListener("click",(event)=>{
        const clicked_tag_element = event.target;
        const clicked_tab_attribute = event.target.getAttribute("data-tab-type");
        document.querySelectorAll(".tab-details-container .tab-details-content-wrapper").forEach((element)=> {
           const tab_details_content_element_attribute_value = element.getAttribute("data-content-type");
           if (tab_details_content_element_attribute_value == clicked_tab_attribute ) {
               document.querySelector(".active-product-detail-tab").classList.remove("active-product-detail-tab");
               document.querySelector(".active-tab-details-content").classList.remove("active-tab-details-content");
               element.classList.add("active-tab-details-content");
               clicked_tag_element.classList.add("active-product-detail-tab");
           }
        })
    })  
})
